// src/constants/image-generation.ts
var IMAGE_MODEL_ID = {
  FLUX_2_DEV: "@cf/black-forest-labs/flux-2-dev",
  FLUX_1_SCHNELL: "@cf/black-forest-labs/flux-1-schnell",
  GEMINI_25_FLASH_IMAGE: "gemini-2.5-flash-image",
  GEMINI_31_FLASH_IMAGE: "gemini-3.1-flash-image-preview",
  GEMINI_3_PRO_IMAGE: "gemini-3-pro-image-preview",
  PHOTON_FLASH_1: "photon-flash-1",
  PHOTON_1: "photon-1",
  GPT_IMAGE_1_MINI: "gpt-image-1-mini",
  GPT_IMAGE_15_MEDIUM: "gpt-image-1.5-medium",
  GPT_IMAGE_15_HIGH: "gpt-image-1.5-high"
};
var CLOUDFLARE_FALLBACK_MODEL = IMAGE_MODEL_ID.FLUX_1_SCHNELL;
var IMAGE_GENERATION_MODELS = {
  [IMAGE_MODEL_ID.FLUX_2_DEV]: {
    id: IMAGE_MODEL_ID.FLUX_2_DEV,
    name: "Flux",
    subModelName: "2 Dev",
    group: "flux",
    isGroupDefault: true,
    provider: "Cloudflare AI",
    providerType: "cloudflare-ai",
    description: "Modelo r\xE1pido e econ\xF4mico de alta qualidade",
    isDefault: true
  },
  [IMAGE_MODEL_ID.GEMINI_25_FLASH_IMAGE]: {
    id: IMAGE_MODEL_ID.GEMINI_25_FLASH_IMAGE,
    name: "NanoBanana",
    subModelName: "v2.5",
    group: "nanobanana",
    isGroupDefault: false,
    provider: "Google",
    providerType: "nanobanana",
    description: "Gera\xE7\xE3o econ\xF4mica com boa qualidade",
    isDefault: false
  },
  [IMAGE_MODEL_ID.GEMINI_31_FLASH_IMAGE]: {
    id: IMAGE_MODEL_ID.GEMINI_31_FLASH_IMAGE,
    name: "NanoBanana",
    subModelName: "2 v3.1",
    group: "nanobanana",
    isGroupDefault: true,
    provider: "Google",
    providerType: "nanobanana",
    description: "Gera\xE7\xE3o premium com textos precisos e alta fidelidade",
    isDefault: false
  },
  [IMAGE_MODEL_ID.GEMINI_3_PRO_IMAGE]: {
    id: IMAGE_MODEL_ID.GEMINI_3_PRO_IMAGE,
    name: "NanoBanana",
    subModelName: "Pro v3.0",
    group: "nanobanana",
    isGroupDefault: false,
    provider: "Google",
    providerType: "nanobanana",
    description: "M\xE1xima qualidade com fidelidade profissional",
    isDefault: false
  },
  [IMAGE_MODEL_ID.PHOTON_FLASH_1]: {
    id: IMAGE_MODEL_ID.PHOTON_FLASH_1,
    name: "Photon",
    subModelName: "Flash",
    group: "photon",
    isGroupDefault: true,
    provider: "Luma AI",
    providerType: "luma",
    description: "Gera\xE7\xE3o ultrarr\xE1pida com est\xE9tica cinematogr\xE1fica",
    isDefault: false
  },
  [IMAGE_MODEL_ID.PHOTON_1]: {
    id: IMAGE_MODEL_ID.PHOTON_1,
    name: "Photon",
    subModelName: "Standard",
    group: "photon",
    isGroupDefault: false,
    provider: "Luma AI",
    providerType: "luma",
    description: "Imagens criativas com est\xE9tica cinematogr\xE1fica",
    isDefault: false
  },
  [IMAGE_MODEL_ID.GPT_IMAGE_1_MINI]: {
    id: IMAGE_MODEL_ID.GPT_IMAGE_1_MINI,
    name: "GPT Image",
    subModelName: "1 Mini",
    group: "gpt-image",
    isGroupDefault: true,
    provider: "OpenAI",
    providerType: "openai-image",
    description: "Econ\xF4mico para gera\xE7\xE3o em massa",
    isDefault: false
  },
  [IMAGE_MODEL_ID.GPT_IMAGE_15_MEDIUM]: {
    id: IMAGE_MODEL_ID.GPT_IMAGE_15_MEDIUM,
    name: "GPT Image",
    subModelName: "1.5 Medium",
    group: "gpt-image",
    isGroupDefault: false,
    provider: "OpenAI",
    providerType: "openai-image",
    description: "Equilibrado entre qualidade e custo",
    isDefault: false
  },
  [IMAGE_MODEL_ID.GPT_IMAGE_15_HIGH]: {
    id: IMAGE_MODEL_ID.GPT_IMAGE_15_HIGH,
    name: "GPT Image",
    subModelName: "1.5 High",
    group: "gpt-image",
    isGroupDefault: false,
    provider: "OpenAI",
    providerType: "openai-image",
    description: "Premium para marketing de alto n\xEDvel",
    isDefault: false
  }
};
var DEFAULT_IMAGE_GENERATION_MODEL = IMAGE_MODEL_ID.FLUX_2_DEV;
var IMAGE_GENERATION_MODEL_IDS = Object.keys(
  IMAGE_GENERATION_MODELS
);
var PROVIDER_DEFAULT_MODEL = {
  "cloudflare-ai": IMAGE_MODEL_ID.FLUX_2_DEV,
  nanobanana: IMAGE_MODEL_ID.GEMINI_31_FLASH_IMAGE,
  luma: IMAGE_MODEL_ID.PHOTON_1,
  "openai-image": IMAGE_MODEL_ID.GPT_IMAGE_1_MINI
};
var OPENAI_MODEL_QUALITY_MAP = {
  [IMAGE_MODEL_ID.GPT_IMAGE_1_MINI]: {
    apiModel: "gpt-image-1",
    quality: "low"
  },
  [IMAGE_MODEL_ID.GPT_IMAGE_15_MEDIUM]: {
    apiModel: "gpt-image-1",
    quality: "medium"
  },
  [IMAGE_MODEL_ID.GPT_IMAGE_15_HIGH]: {
    apiModel: "gpt-image-1",
    quality: "high"
  }
};
var IMAGE_GENERATION_GROUPS = {
  flux: {
    id: "flux",
    name: "Flux",
    provider: "Cloudflare AI",
    description: "Modelo r\xE1pido e econ\xF4mico de alta qualidade",
    isDefault: true,
    modelIds: [IMAGE_MODEL_ID.FLUX_2_DEV]
  },
  nanobanana: {
    id: "nanobanana",
    name: "NanoBanana",
    provider: "Google",
    description: "Gera\xE7\xE3o premium com textos precisos e alta fidelidade",
    isDefault: false,
    modelIds: [
      IMAGE_MODEL_ID.GEMINI_25_FLASH_IMAGE,
      IMAGE_MODEL_ID.GEMINI_31_FLASH_IMAGE,
      IMAGE_MODEL_ID.GEMINI_3_PRO_IMAGE
    ]
  },
  photon: {
    id: "photon",
    name: "Photon",
    provider: "Luma AI",
    description: "Imagens criativas com est\xE9tica cinematogr\xE1fica",
    isDefault: false,
    modelIds: [IMAGE_MODEL_ID.PHOTON_FLASH_1, IMAGE_MODEL_ID.PHOTON_1]
  },
  "gpt-image": {
    id: "gpt-image",
    name: "GPT Image",
    provider: "OpenAI",
    description: "Gera\xE7\xE3o vers\xE1til com alta compreens\xE3o de prompts",
    isDefault: false,
    modelIds: [
      IMAGE_MODEL_ID.GPT_IMAGE_1_MINI,
      IMAGE_MODEL_ID.GPT_IMAGE_15_MEDIUM,
      IMAGE_MODEL_ID.GPT_IMAGE_15_HIGH
    ]
  }
};
var IMAGE_GENERATION_GROUP_IDS = Object.keys(
  IMAGE_GENERATION_GROUPS
);
function getImageGenerationModelInfo(modelId) {
  return IMAGE_GENERATION_MODELS[modelId] ?? null;
}
function isValidImageGenerationModel(modelId) {
  return modelId in IMAGE_GENERATION_MODELS;
}
function getImageProviderType(modelId) {
  const model = IMAGE_GENERATION_MODELS[modelId];
  if (model) {
    return model.providerType;
  }
  return "cloudflare-ai";
}
function getGroupForModel(modelId) {
  const model = getImageGenerationModelInfo(modelId);
  return model?.group ?? null;
}
function getGroupDefaultModel(groupId) {
  const group = IMAGE_GENERATION_GROUPS[groupId];
  for (const modelId of group.modelIds) {
    if (IMAGE_GENERATION_MODELS[modelId].isGroupDefault) {
      return modelId;
    }
  }
  return group.modelIds[0];
}

export {
  IMAGE_MODEL_ID,
  CLOUDFLARE_FALLBACK_MODEL,
  IMAGE_GENERATION_MODELS,
  DEFAULT_IMAGE_GENERATION_MODEL,
  IMAGE_GENERATION_MODEL_IDS,
  PROVIDER_DEFAULT_MODEL,
  OPENAI_MODEL_QUALITY_MAP,
  IMAGE_GENERATION_GROUPS,
  IMAGE_GENERATION_GROUP_IDS,
  getImageGenerationModelInfo,
  isValidImageGenerationModel,
  getImageProviderType,
  getGroupForModel,
  getGroupDefaultModel
};
//# sourceMappingURL=chunk-TWPIXBC3.js.map